import { StrictMode, useEffect, useState, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { api } from './lib/api'
import { getToken } from './lib/auth'
import { basePath } from './lib/basePath'
import { ConfiguracaoPolitica } from './pages/ConfiguracaoPolitica'
import { Debug } from './pages/Debug'
import { DemoAoVivo } from './pages/DemoAoVivo'
import { Linha } from './pages/Linha'
import { Login } from './pages/Login'
import { Menu } from './pages/Menu'
import { WhatsApp } from './pages/WhatsApp'
import './theme/global.css'

/**
 * Porteiro das telas: com APP_PASSWORD no servidor, quem chega sem token vai
 * para /login. Token velho (serviço reiniciado) é resolvido pelo cliente de
 * API, que devolve ao login no primeiro 401.
 */
function Guard({ children }: { children: ReactNode }) {
  const [required, setRequired] = useState<boolean | null>(null)

  useEffect(() => {
    api
      .authStatus()
      .then((status) => setRequired(status.required))
      // Backend fora do ar: deixa as telas subirem e mostrarem o erro delas.
      .catch(() => setRequired(false))
  }, [])

  if (required === null) return null
  if (required && !getToken()) return <Navigate to="/login" replace />
  return <>{children}</>
}

const root = document.getElementById('root')
if (!root) throw new Error('Elemento #root não encontrado')

createRoot(root).render(
  <StrictMode>
    {/* basename vazio na raiz; sob prefixo, o React Router ignora o /stratumtech
        ao casar as rotas — sem isto, todas cairiam no catch-all. */}
    <BrowserRouter basename={basePath || undefined}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <Guard>
              <Routes>
                <Route path="/" element={<Menu />} />
                <Route path="/console" element={<DemoAoVivo />} />
                <Route path="/politica" element={<ConfiguracaoPolitica />} />
                <Route path="/linha" element={<Linha />} />
                <Route path="/linha-2" element={<Linha variant="b" />} />
                <Route path="/whatsapp" element={<WhatsApp />} />
                <Route path="/debug" element={<Debug />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Guard>
          }
        />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
